<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-3">
            <div class="row align-items-center">
              <div class="col-sm-4 col-form-label text-right">
                Date
              </div>
              <div class="col-sm-8">
                <flat-pickr :config="dateConfig" @on-change="changeDate" v-model="filterDate" class="form-control font-13"></flat-pickr>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="row align-items-center">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch" class="form-control">
                  <option :value="null">All Branch</option>
                  <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="row align-items-center">
              <div class="col-sm-4 col-form-label text-right">
                Class / Session
              </div>
              <div class="col-sm-8">
                <b-form-select name="booking_type" v-model="bookingType" @change="changeBookingType" class="form-control">
                  <option :value="null">All</option>
                  <option value="class">Class</option>
                  <option value="session">Session</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-3" v-if="bookingType === 'session'">
            <div class="row align-items-center">
              <div class="col-sm-4 col-form-label text-right">
                Personal Trainer
              </div>
              <div class="col-sm-8">
                <b-form-select name="personal_trainer" v-model="personalTrainerId" @change="changeFilter" class="form-control">
                  <option :value="null">All PT</option>
                  <option v-for="item in filteredPersonalTrainers" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-3" v-if="bookingType === 'class'">
            <div class="row align-items-center">
              <div class="col-sm-4 col-form-label text-right">
                Coach
              </div>
              <div class="col-sm-8">
                <b-form-select name="coach" v-model="coachId" @change="changeFilter" class="form-control">
                  <option :value="null">All Coach</option>
                  <option v-for="item in filteredCoaches" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="changeFilter" v-model="keyword" class="form-control" placeholder="Search member name">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table :hover="true" :striped="true" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :busy="loadingActive">
          <template v-slot:cell(member)="data">
            <template v-if="data.item.member">
              {{ data.item.member.first_name }} {{ data.item.member.last_name }}
            </template>
            <template v-else>-</template>
          </template>
          <template v-slot:cell(class_date)="data">
            {{ parseDate(data.item.class_date) }}
          </template>
          <template v-slot:cell(time_start)="data">
            {{ parseTime(data.item.time_start) }}
          </template>
          <template v-slot:cell(branch_name)="data">
            {{ data.item.branch_name || '-' }}
          </template>
          <template v-slot:cell(staff)="data">
            <template v-if="data.item.is_pt_booking">
              {{ data.item.personal_trainer_name || '-' }} <b-badge variant="info">PT</b-badge>
            </template>
            <template v-else>
              {{ data.item.coach_name || '-' }} <b-badge variant="secondary">Coach</b-badge>
            </template>
          </template>
          <template v-slot:cell(status)="data">
            <b-badge :variant="data.item.is_expired ? 'danger' : 'success'">
              {{ data.item.is_expired ? 'Expired' : 'Upcoming' }}
            </b-badge>
          </template>
          <template v-slot:cell(action)="data">
            <b-button size="sm" :disabled="data.item.is_expired" @click="cancelBooking(data.item)" class="btn-table red">
              <i class="fas fa-times mr-5"></i>Cancel
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
          :total-pages="totalPage"
          @page-changed="pageOneChanged"
          prev-text="Prev" next-text="Next" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Pagination from "@/views/component/pagination";
import moment from "moment";

export default {
  name: "memberBookings",
  components: {
    "app-pagination": Pagination,
  },
  data() {
    return {
      fields: [
        { key: "member", label: "Member" },
        { key: "member.phone_number", label: "Phone Number" },
        { key: "branch_name", label: "Branch" },
        { key: "class_name", label: "Class / Session" },
        { key: "staff", label: "PT / Coach" },
        { key: "class_date", label: "Date" },
        { key: "time_start", label: "Time" },
        { key: "status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      items: [],
      dataBranch: [],
      dataPersonalTrainer: [],
      dataCoach: [],
      branch_id: null,
      bookingType: null,
      personalTrainerId: null,
      coachId: null,
      keyword: "",
      filterDate: moment(new Date()).format("YYYY-MM-DD"),
      dateConfig: {
        mode: "single",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
      },
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      loadingActive: false,
    };
  },
  computed: {
    filteredPersonalTrainers() {
      if (this.branch_id == null) return this.dataPersonalTrainer;
      return this.dataPersonalTrainer.filter((item) => item.branch_id == this.branch_id);
    },
    filteredCoaches() {
      if (this.branch_id == null) return this.dataCoach;
      return this.dataCoach.filter((item) => item.branch_id == this.branch_id);
    },
  },
  methods: {
    parseDate(value) {
      return moment(value).format("DD MMM YYYY");
    },
    parseTime(value) {
      return value ? value.slice(0, 5) : "-";
    },
    // flatpickr's on-change fires with (selectedDates, dateStr, instance) - use dateStr
    // directly instead of reading v-model's filterDate, which only gets updated by the
    // component's own internal listener and isn't guaranteed to have flushed yet by the
    // time this handler runs (that's what caused the "need to click twice" bug).
    changeDate(selectedDates, dateStr) {
      this.filterDate = dateStr;
      this.currentPage = 1;
      this.fetchData();
    },
    changeBranch() {
      this.currentPage = 1;
      this.fetchData();
    },
    changeBookingType() {
      this.personalTrainerId = null;
      this.coachId = null;
      this.currentPage = 1;
      this.fetchData();
    },
    changeFilter() {
      this.currentPage = 1;
      this.fetchData();
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum;
      this.fetchData();
    },
    fetchData() {
      this.loadingActive = true;
      let url =
        "crm/v1/member_bookings?page=" +
        this.currentPage +
        "&limit=" +
        this.paginationLimit +
        "&date=" +
        this.filterDate;

      if (this.branch_id != null) {
        url += "&branch_id=" + this.branch_id;
      }
      if (this.bookingType != null) {
        url += "&booking_type=" + this.bookingType;
      }
      if (this.bookingType === "session" && this.personalTrainerId != null) {
        url += "&personal_trainer_id=" + this.personalTrainerId;
      }
      if (this.bookingType === "class" && this.coachId != null) {
        url += "&coach_id=" + this.coachId;
      }
      if (this.keyword) {
        url += "&keyword=" + this.keyword;
      }

      axios
        .get(url)
        .then((response) => {
          this.items = response.data.data.rows;
          this.totalPage = response.data.meta.pageCount;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loadingActive = false;
        });
    },
    fetchFilterData() {
      axios
        .get("fitness/v1/branch/")
        .then((response) => {
          this.dataBranch = response.data.data.rows;
        })
        .catch((error) => {
          console.log("error", error);
        });

      axios
        .get("fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc")
        .then((response) => {
          this.dataPersonalTrainer = response.data.data.rows;
        })
        .catch((error) => {
          console.log("error", error);
        });

      axios
        .get("fitness/v1/coaches?status=active&sorting=name&sorting_type=asc")
        .then((response) => {
          this.dataCoach = response.data.data.rows;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    cancelBooking(item) {
      this.$swal({
        title: "Are you sure?",
        text: "This booking will be cancelled and can't be reverted",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Cancel Booking!",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: false,
      }).then((confirm) => {
        if (!confirm.value) return;

        axios
          .delete("crm/v1/member_bookings/cancel/" + item.id)
          .then(() => {
            this.$toast.success("Booking has been cancelled!", "Success", {
              position: "topCenter",
              icon: "icon-envelope",
              progressBarColor: "rgb(0, 255, 184)",
              theme: "dark",
              backgroundColor: "#565c70",
              messageColor: "#fff",
            });
            this.fetchData();
          })
          .catch((error) => {
            const errMsg = error.response.data;
            this.$toast.success(errMsg.error, "Error", {
              position: "topCenter",
              icon: "icon-envelope",
              progressBarColor: "rgb(0, 255, 184)",
              theme: "dark",
              backgroundColor: "#565c70",
              messageColor: "#fff",
              timeout: 5000,
            });
          });
      });
    },
  },
  created() {
    this.fetchFilterData();
    this.fetchData();
  },
};
</script>

<style>
</style>
